import React from 'react'
import { Nav,Navbar,Container } from 'react-bootstrap'
import logo from '../assets/logo.jpg';
import {Link} from 'react-router-dom';
import './Nav2.css';
export default function Nav2() {
    const change = (event)=>{
        const elements =document.getElementsByClassName('selected');
        const element=Object.values(elements);
         element.forEach(el => {
            console.log(el.className); 
           el.className="";
           console.log(el.className);
         });
        
        event.target.className="selected";
    }
    return (
        <div>
           <Navbar bg="white" expand="lg">
  <Container fluid>
    <Navbar.Brand href="#">
    <img src={logo}></img>
    </Navbar.Brand>
    <Navbar.Toggle  />
    <Navbar.Collapse >
      <Nav
         className="me-auto my-2 my-lg-0"
        
    
      >
        <Link onClick={change} to="/">
                    Home
                </Link>
                <Link onClick={change} to="/Reservation">
                    Reservation
                </Link>
                <a href="#contact">
                    Contact </a>
        
      </Nav>
     
    </Navbar.Collapse>
  </Container>
</Navbar>
        </div>
    )
}
